module.exports = __webpack_public_path__ + "img/主效果图.64d92a1b.jpg";